module.exports = __webpack_public_path__ + "static/media/2030113000.ec6f0485.jpg";